import React, { useState } from 'react';
import { Button } from '../ui/button';
import { STATUS_CODES, BUTTON_LABELS, API_ENDPOINT, TOKEN_KEY, ERROR_MESSAGES } from '../../constants';

const OrderActions = ({ statusCode, orderId, onStatusUpdate, onError }) => {
  const [loading, setLoading] = useState(false);

  const updateOrderStatus = async (newStatusCode) => {
    try {
      setLoading(true);
      const token = localStorage.getItem(TOKEN_KEY);
      
      const response = await fetch(`${API_ENDPOINT}/order/addStatus`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          statusCode: String(newStatusCode),
          orderIds: [orderId],
          createdAt: new Date().toISOString(),
          description: newStatusCode === 100 ? 'Finding rider' : '-',
        }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Assuming you have access to logout function
          // logout();
          return;
        }
        const errorData = await response.json();
        throw new Error(errorData.message || ERROR_MESSAGES.UPDATE_FAILED);
      }

      const data = await response.json();
      // Callback to parent component to update UI
      if (onStatusUpdate) {
        onStatusUpdate(data);
      }
      // Show success message if needed
    } catch (error) {
      console.error('Error updating order status:', error);
      if (onError) {
        onError(error.message || ERROR_MESSAGES.UPDATE_FAILED);
      }
    } finally {
      setLoading(false);
    }
  };

  if (statusCode >= STATUS_CODES.PICKUP.min && statusCode < STATUS_CODES.PICKUP.max) {
    return (
      <div className="space-x-2">
        <Button 
          size="sm" 
          variant="outline"
          className="bg-white hover:bg-gray-100 text-gray-900 border border-gray-300"
          onClick={() => updateOrderStatus(500)}
          disabled={loading}
        >
          {loading ? 'Updating...' : BUTTON_LABELS.PICKUP}
        </Button>
        <Button 
          size="sm" 
          variant="destructive"
          className="bg-white hover:bg-red-50 text-red-600 border border-red-300"
          onClick={() => updateOrderStatus(475)}
          disabled={loading}
        >
          {loading ? 'Updating...' : BUTTON_LABELS.PICKUP_FAILED}
        </Button>
      </div>
    );
  }

  if (statusCode >= STATUS_CODES.ASSIGN_DRIVER.min && statusCode < STATUS_CODES.ASSIGN_DRIVER.max) {
    return (
      <Button
        size="sm"
        variant="outline"
        className="bg-white hover:bg-gray-100 text-gray-900 border border-gray-300"
        onClick={() => updateOrderStatus(100)}
        disabled={loading}
      >
        {loading ? 'Updating...' : BUTTON_LABELS.ASSIGN_DRIVER}
      </Button>
    );
  }
  

  if (statusCode >= STATUS_CODES.IN_TRANSIT.min && statusCode < STATUS_CODES.IN_TRANSIT.max) {
    return (
      <Button 
        size="sm" 
        variant="outline"
        className="bg-white hover:bg-gray-100 text-gray-900 border border-gray-300"
        onClick={() => updateOrderStatus(600)}
        disabled={loading}
      >
        {loading ? 'Updating...' : BUTTON_LABELS.IN_TRANSIT}
      </Button>
    );
  }

  if (statusCode >= STATUS_CODES.DELIVERY.min && statusCode < STATUS_CODES.DELIVERY.max) {
    return (
      <div className="space-x-2">
        <Button 
          size="sm" 
          variant="outline"
          className="bg-white hover:bg-gray-100 text-gray-900 border border-gray-300"
          onClick={() => updateOrderStatus(700)}
          disabled={loading}
        >
          {loading ? 'Updating...' : BUTTON_LABELS.DELIVERED}
        </Button>
        <Button 
          size="sm" 
          variant="destructive"
          className="bg-white hover:bg-red-50 text-red-600 border border-red-300"
          onClick={() => updateOrderStatus(650)}
          disabled={loading}
        >
          {loading ? 'Updating...' : BUTTON_LABELS.DELIVERY_FAILED}
        </Button>
        {statusCode === STATUS_CODES.DELIVERY.min && (
          <Button
            size="sm"
            variant="secondary"
            className="bg-white hover:bg-gray-100 text-gray-900 border border-gray-300"
            onClick={() => updateOrderStatus(701)}
            disabled={loading}
          >
            {loading ? 'Updating...' : BUTTON_LABELS.RETURN}
          </Button>
        )}
      </div>
    );
  }

  if (statusCode === STATUS_CODES.RETURN.min) {
    return (
      <Button 
        size="sm" 
        variant="secondary"
        className="bg-white hover:bg-gray-100 text-gray-900 border border-gray-300"
        onClick={() => updateOrderStatus(701)}
        disabled={loading}
      >
        {loading ? 'Updating...' : BUTTON_LABELS.RETURN}
      </Button>
    );
  }

  return null;
};

export default OrderActions;